var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconIron = function SvgIconIron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-iron_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m24 5-.656.627-.003.004-.009.008-.03.03-.116.113q-.153.15-.433.432a68.62 68.62 0 0 0-6.168 7.24c-3.338 4.54-6.835 10.623-6.835 16.322C9.75 37.153 16.206 43 24 43s14.25-5.847 14.25-13.224c0-5.7-3.497-11.781-6.835-16.321a69 69 0 0 0-6.168-7.24 41 41 0 0 0-.549-.547l-.03-.03-.009-.007zm-1.379 4.117c.558-.608 1.03-1.1 1.379-1.457a66.71 66.71 0 0 1 5.885 6.925c3.312 4.505 6.465 10.153 6.465 15.191 0 6.178-5.453 11.318-12.35 11.318s-12.35-5.14-12.35-11.318c0-5.038 3.153-10.686 6.465-15.19a67 67 0 0 1 4.506-5.469",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M28.23 33.644c-2.248 0-3.488-1.771-3.488-3.57 0-1.81 1.117-3.513 3.365-3.513 2.288 0 3.323 1.675 3.323 3.31 0 .231-.014.45-.027.585h-5.04c.136 1.09.817 1.798 1.866 1.798.858 0 1.43-.354 1.594-1.008h1.634c-.245 1.458-1.525 2.398-3.228 2.398m-1.826-4.332h3.364c-.068-.872-.667-1.485-1.661-1.485-.927 0-1.512.518-1.703 1.485M18.264 33.535V24h6.334v1.553h-4.55v2.424H23.7v1.553h-3.65v4.005z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-iron_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgIconIron;